if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
        this.sellingPlanInputs = this.querySelectorAll('[js-variant-selling-plan]')
        this.setupReviewTags();
      }

      cartUpdateUnsubscriber = undefined;
      variantChangeUnsubscriber = undefined;

      connectedCallback() {
        // this.updatePriceUpsellProduct();
        if (this.sellingPlanInputs) {
          this.handleSellingPlan();
        }
        if (!this.input) return;
        this.quantityForm = this.querySelector('.product-form__quantity');
        if (!this.quantityForm) return;
        this.setQuantityBoundries();
        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, this.fetchQuantityRules.bind(this));
        }
        this.variantChangeUnsubscriber = subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
          const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
          if (event.data.sectionId !== sectionId) return;
          this.updateQuantityRules(event.data.sectionId, event.data.html);
          this.setQuantityBoundries();
        });
      }

      setupReviewTags() {
        const reviewTags = this.querySelectorAll('.stamped-product-reviews-badge, [js-custom-review-badge-wrapper]');
        for(let i = 0; i < reviewTags.length; i++) {
          const reviewTag = reviewTags[i];
          const productId = reviewTag.getAttribute('data-id');
          const mainWidget = document.querySelector('#stamped-main-widget[data-product-id="' + productId + '"]');
          if(!mainWidget) {
            return;
          }

          reviewTag.addEventListener('click', function() {
            let top = mainWidget.getBoundingClientRect().top;
            top = top - 100;
            window.scrollBy({
              top: top,
              behavior: 'smooth'
            });
          });
        }
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
        if (this.variantChangeUnsubscriber) {
          this.variantChangeUnsubscriber();
        }
      }

      handleSellingPlan() {
        this.sellingPlanInputs.forEach(input => {
          input.addEventListener('change', () => {
            this.updatePriceBySellingPlan(input);
          })
          if (input.checked) {
            this.updatePriceBySellingPlan(input);
          }
        });
      }

      updatePriceBySellingPlan(input) {
        
        if (input.checked) {
          const priceLast = input.parentNode.querySelector('.js-selling-plan-price-last').innerHTML
          const priceRegular = input.parentNode.querySelector('.js-selling-plan-price-regular').innerHTML
          this.querySelectorAll('.js-price-last')?.forEach(ele => {
            ele.innerHTML = priceLast
          })

          this.querySelectorAll('.js-price-regular')?.forEach(ele => {
            ele.innerHTML = priceRegular
          })
        }
      }

      setQuantityBoundries() {
        const data = {
          cartQuantity: this.input.dataset.cartQuantity ? parseInt(this.input.dataset.cartQuantity) : 0,
          min: this.input.dataset.min ? parseInt(this.input.dataset.min) : 1,
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: this.input.step ? parseInt(this.input.step) : 1,
        };

        let min = data.min;
        const max = data.max === null ? data.max : data.max - data.cartQuantity;
        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);
        this.input.min = min;

        if (max) {
          this.input.max = max;
        } else {
          this.input.removeAttribute('max');
        }
        this.input.value = min;
        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant || !this.currentVariant.value) return;
        this.querySelector('.quantity__rules-cart .loading__spinner').classList.remove('hidden');
        fetch(`${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`)
          .then((response) => {
            return response.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.querySelector('.quantity__rules-cart .loading__spinner').classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];
        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);
          if (!current || !updated) continue;
          if (selector === '.quantity__input') {
            const attributes = ['data-cart-quantity', 'data-min', 'data-max', 'step'];
            for (let attribute of attributes) {
              const valueUpdated = updated.getAttribute(attribute);
              if (valueUpdated !== null) {
                current.setAttribute(attribute, valueUpdated);
              } else {
                current.removeAttribute(attribute);
              }
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }

      // updatePriceUpsellProduct() {
      //   const upsellToggle = this.querySelector('.js-upsell-toggle');
      //   const addtocartBtn = this.querySelector('button[js-variant-add-to-bag]');
      //   const priceLast = addtocartBtn.querySelector('.js-price-last');
      //   const priceRegular = addtocartBtn.querySelector('.js-price-regular');
      //   const currentProduct = this.querySelector('.js-main-product-upsell');
        
      //   if (!upsellToggle || !currentProduct || !priceLast || !priceRegular) return
      //   upsellToggle.addEventListener('click', () => {
      //     console.log("js-upsell-toggle");
          
      //     let upsellPrice = Number(upsellToggle.dataset.price);
      //     let upsellCompareAtPrice = Number(upsellToggle.dataset.compareAtPrice);
      //     let upsellCurrency = window.shopCurrency.moneyCurrencyFormat.split('{{amount}}')[0];

      //     priceLast.innerHTML = upsellCurrency + upsellPrice;
      //     priceRegular.innerHTML = upsellCurrency + upsellCompareAtPrice;

      //     if (!upsellToggle.checked) {
      //       priceLast.innerHTML = upsellCurrency + currentProduct.dataset.price;
      //       priceRegular.innerHTML = upsellCurrency + currentProduct.dataset.compareAtPrice;
  
      //     }
      //   })
      // }
    }
  );
}
